import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/customer/$customerId/_layout/compliance')({
  component: RouteComponent
});
function RouteComponent() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}